import { render, staticRenderFns } from "./TeamSearch.vue?vue&type=template&id=1789a966&"
import script from "./TeamSearch.vue?vue&type=script&lang=js&"
export * from "./TeamSearch.vue?vue&type=script&lang=js&"
import style0 from "./TeamSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports